import getStrapiUrl from "../utils/strapiUrl";

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);

const resolveMediaUrl = (url) => {
  if (!url) {
    return "";
  }
  // Strapi Cloud already returns absolute CDN URLs; local/dev returns relative paths.
  if (isAbsoluteUrl(url)) {
    return url;
  }
  return `${getStrapiUrl()}${url}`;
};

const StrapiImage = (image, size) => {
  if (!image) {
    return "";
  }

  if (size && image.formats && image.formats[size] && image.formats[size].url) {
    return resolveMediaUrl(image.formats[size].url);
  }

  // No size provided (or requested size missing): always default to the main url,
  // even when other formats are available
  if (image.url) {
    return resolveMediaUrl(image.url);
  }

  return "";
};

export default StrapiImage;
